import { GridColDef } from "@mui/x-data-grid-premium";
import { Document, Page, Text, StyleSheet, View } from "@react-pdf/renderer";
import React from "react";

interface Props {
  columns: GridColDef[];
  rows: any[];
}

const ReportExportPdf: React.FC<Props> = (props) => {
  const { columns, rows } = props;
  return (
    <Document>
      <Page
        size={
          columns.length <= 8
            ? "A4"
            : columns.length <= 12
            ? "A3"
            : columns.length <= 16
            ? "A2"
            : columns.length <= 20
            ? "A1"
            : "A0"
        }
        orientation="landscape"
        style={{ padding: "40px" }}
      >
        <Text
          style={{ fontSize: "30px", marginBottom: "5px", color: "#26549e" }}
        >
          Detector Report
        </Text>
        <View style={{ display: "flex", flexDirection: "column", flex: 1 }}>
          <View style={styles.tableRow}>
            {columns.map((column) => (
              <View key={column.headerName}>
                <Text style={{ ...styles.headerText, flex: 1 }}>
                  {column.headerName}
                </Text>
              </View>
            ))}
          </View>
          {rows.map((row) => {
            return (
              <View style={styles.tableRow}>
                {columns.map((column, index) => (
                  <View key={index}>
                    <Text
                      style={{
                        ...styles.tableText,
                        flex: 1,
                        borderRight:
                          index === columns.length - 1
                            ? "1px solid black"
                            : undefined,
                      }}
                    >
                      {row[column["field"]]}
                    </Text>
                  </View>
                ))}
              </View>
            );
          })}
        </View>
      </Page>
    </Document>
  );
};

const styles = StyleSheet.create({
  headerText: {
    fontSize: "10px",
    fontWeight: "bold",
    textAlign: "center",
    padding: "2px",
  },
  tableRow: {
    display: "flex",
    flexDirection: "row",
    borderBottom: "1px solid black",
  },
  tableText: {
    fontSize: "8.5px",
    textAlign: "left",
    padding: "2px",
    borderLeft: "1px solid black",
    display: "flex",
    alignContent: "center",
  },
});

export default ReportExportPdf;
